import React from 'react';
import InfoDialog from '@au/core/lib/components/objects/InfoDialog';
import AutoIntl from '@au/core/lib/components/elements/AutoIntl';
import { BUTTON_TYPE_PRIMARY } from '@au/core/lib/components/elements/AuButton';
import { createResponseAlertMessage } from '@au/core/lib/components/objects/AlertMessage';
import DefaultList from '../List';
import Banner, { BANNER_TYPE_WARNING } from '../../Banner';
import SyncConversionRuleDialog from '../../SyncConversionRuleDialog';
import { wrapActionWithTracking } from '../../../utils/analyticsHelpers';
import { clearMountedFlag, fetchAllowedEnvironments } from '../../../utils/telemetryUtils';

import styles from '../../../css/components/sync_configs_list.module.scss';

export default class SyncConfigsList extends DefaultList {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      showSyncNowDialog: false,
      showSuccessDialog: false,
      selectedSyncId: null,
      allowedEnvs: [],
    };

    this.onSyncNowClick = this.onSyncNowClick.bind(this);
    this.refreshList = this.refreshList.bind(this);
  }

  componentDidMount() {
    super.componentDidMount();
    fetchAllowedEnvironments(this);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    clearMountedFlag(this);
  }

  getFilteredEntities() {
    const entities = super.getFilteredEntities();
    return entities.filter((entity) => !entity.get('localLiveId'));
  }

  getBanner() {
    if (this.state.ready && this.state.allowedEnvs.length === 0) {
      return <Banner type={BANNER_TYPE_WARNING} displayId='au.telemetry.sync.forbidden' />;
    }

    return false;
  }

  getRowActions({ id, canWrite, canReplicate, permissions }) {
    const baseActions = super.getRowActions({ id, canWrite, canReplicate, permissions });
    const { entityAlias } = this.props.match.params;

    const triggerAction = wrapActionWithTracking(
      {
        displayId: 'au.entity.action.syncNow',
        onClick: this.onSyncNowClick.bind(this, id),
      },
      entityAlias,
      'List',
    );

    return [baseActions[0], triggerAction, ...baseActions.slice(1)];
  }

  renderDialogs() {
    const { showSyncNowDialog, showSuccessDialog, selectedSyncId } = this.state;
    const dialogs = [];

    if (showSyncNowDialog && selectedSyncId) {
      const syncConfig = this.props.entities.get(selectedSyncId).toJS();
      dialogs.push(
        <SyncConversionRuleDialog
          onConfirm={this.handleSyncConfirmation.bind(this)}
          onCancel={this.handleSyncCancel.bind(this)}
          syncConfig={syncConfig}
        />,
      );
    }

    if (showSuccessDialog) {
      dialogs.push(
        <InfoDialog
          key='SuccessCreate'
          titleId='au.entity.success'
          className={styles.success_dialog}
          bodyClassName={styles.success_dialog_body}
          closeClassName={styles.success_dialog_close_button}
          buttonType={BUTTON_TYPE_PRIMARY}
          showClose={false}
          onClose={this.handleSuccessDialogClosed.bind(this)}
        >
          <AutoIntl displayId='au.telemetry.sync.success' tag='div' />
        </InfoDialog>,
      );
    }

    return dialogs;
  }

  onSyncNowClick(syncId) {
    this.setState({ showSyncNowDialog: true, selectedSyncId: syncId });
  }

  async handleSyncConfirmation(syncId, targetEnv) {
    try {
      await this.props.endpoint.triggerSync(syncId, targetEnv);
      this.setState({ showSyncNowDialog: false, showSuccessDialog: true });
    } catch (e) {
      this.setState({ showSyncNowDialog: false });
      createResponseAlertMessage(e);
    }
  }

  handleSyncCancel() {
    this.setState({ showSyncNowDialog: false, selectedSyncId: null });
  }

  handleSuccessDialogClosed() {
    this.setState({ showSuccessDialog: false });
    this.refreshList();
  }

  refreshList() {
    this.setState({ cancel: false, showError: false, ready: false });
    this.resetPages();
    this.fetchInitialPages()
      .then(() => this.setState({ ready: true }))
      .catch(createResponseAlertMessage);
  }
}
